<template>
    <v-content>
        <div>

        </div>
        <v-container fluid fill-height>
            <v-layout align-center justify-center>
                <v-flex xs12 sm8 md4>
                    <v-card class="elevation-12">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>{{$t('Login')}}</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <form class="login" @submit.prevent="login" novalidate>
                            <v-card-text>
                                <v-text-field v-model="email" name="email" required :label="$t('e-mail')" type="text"></v-text-field>
                                <v-text-field v-model="password" name="password" required :label="$t('password')" type="password"></v-text-field>
                            </v-card-text>
                            <div id="login-message" v-if="errorMessage">{{errorMessage}}</div>
                            <v-card-actions>
                                <router-link to="/forgotpassword" class="forgotlink">{{$t('Forgot password')}}?</router-link>
                              <v-spacer></v-spacer>
                                <v-btn color="primary" type="submit">{{$t('Login')}}</v-btn>
                            </v-card-actions>
                        </form>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</template>

<script>
    export default {
        data(){
            return {
                email : "",
                password : "",
                errorMessage: false
            }
        },
        methods: {
            login: function () {
                let email = this.email
                let password = this.password
                if (email === '') {
                    this.errorMessage = this.$t('E-mail is required');
                    return false;
                }
                if (password === '') {
                    this.errorMessage = this.$t('Password is required');
                    return false;
                }
                this.errorMessage = false;
                this.$store.dispatch('login', { email, password })
                    .then(() => this.$router.push('/'))
                    .catch(err => this.showErrorMessage(err));
            },
            showErrorMessage: function(err) {
                this.errorMessage = this.$t(err.response.data.error);
            }
        }
    }
</script>

<style scoped>
  #login-message {color: red; background: #ffe6e6; margin: 0 16px 10px; line-height: 24px; border-radius: 2px;}
  .forgotlink {margin-left: 10px; color: #999;}
</style>



// WEBPACK FOOTER //
// src/views/account/Login.vue